import { Capacitor } from "../_stubs/capacitorCore";

/**
 * Hint coins wallet — separate from puzzle-unlock credits ({@link SLIDING_CREDIT_APP_CODE}).
 * Backend: `mo_apps.code` = `sliding_puzzle_quest_hints`, product group `appleSlidingPuzzleQuestHints`.
 */
export const HINT_POINTS_APP_CODE = "sliding_puzzle_quest_hints";

export const HINT_POINTS_PRODUCT_GROUP = "appleSlidingPuzzleQuestHints";

/** RevenueCat package id in the default offering (configure in RevenueCat dashboard). */
export const HINT_POINTS_PACKAGE_ID = "hints_pocket";

/**
 * App Store consumable — create in App Store Connect @ $1.99, 2000 assistant coins.
 * Must match backend `application.yml` and RevenueCat product mapping.
 */
export const HINT_POINTS_PRODUCT_ID = "com.pzl.sliding.quest.hints.pocket";

export const HINT_POINTS_PACK_AMOUNT = 2000;

/** Free / guest tier — local-only ghost-guide budget (not synced to server). */
export const GUEST_FREE_HINTS_INITIAL = 200;

/** Spent per ghost-guide hint tap. */
export const HINT_POINT_COST = 10;

/** Logged in `mo_credit_usage_logs.feature_used`. */
export const HINT_POINTS_FEATURE_GHOST_GUIDE = "ghost_guide_hint";

export const HINT_POINTS_SUGGESTED_PRICE_CAD = 1.99;

export function shouldUseSuggestedHintPointsPriceFallback() {
    try {
        return !Capacitor.isNativePlatform();
    } catch {
        return true;
    }
}

export function getSuggestedHintPointsPackPrice({ currency = "CAD" } = {}) {
    const amount = HINT_POINTS_SUGGESTED_PRICE_CAD;
    if (currency === "CAD" || currency === "USD") {
        return `$${amount.toFixed(2)}`;
    }
    return `${amount.toFixed(2)} ${currency}`;
}

export function formatHintPointsPackLabel(livePriceString, { allowCadFallback = true } = {}) {
    const live = typeof livePriceString === "string" ? livePriceString.trim() : "";
    if (live) {
        return `${live} · ${HINT_POINTS_PACK_AMOUNT} assistant coins`;
    }
    if (!allowCadFallback || !shouldUseSuggestedHintPointsPriceFallback()) {
        return `${HINT_POINTS_PACK_AMOUNT} assistant coins`;
    }
    return `${getSuggestedHintPointsPackPrice()} · ${HINT_POINTS_PACK_AMOUNT} assistant coins`;
}
